// Shared caps for free-text user inputs. Must stay in sync with the
// server-side limits (backend `app/common_utils.py`) so the UI never lets a
// user type something the API will reject.

export const PROJECT_NAME_MAX_LENGTH = 100;
